<template>
  <section class="features-section-container">
    <div class="content-wrapper">
      <div class="title">
        <h2>mitől működik?</h2>
        <div id="underline"></div>
      </div>
      <div class="cards">

        <div class="card" v-on:mouseleave="mouseleave">
          <div class="card-content-wrapper">
            <div class="card-front">
              <img class="card-icon" src="../assets/feature_logos/feather-alt-solid.svg" alt="feather">
            </div>
            <div class="card-back">
              <h3>alacsony tömeg</h3>
              <p>A fokos könnyű fegyver, még a leghosszabb verziók sem haladták meg az egy kilós tömeget, ami lehetővé tette a mindennapi viselést, illetve megkönnyítette a csaták során a harcos által cipelt súlyt. A mindennapos használat lehetővé tette az eszköz forgatásának alapos elsajátítását. A könnyű hordozhatóság felbecsülhetetlen, hiszen ha nincs nálad, nem mentheti meg az életed!</p>
            </div>
            <img class="aspect-ratio-guard" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="aspect-ratio-guard">
          </div>
        </div>

        <div class="card" v-on:mouseleave="mouseleave">
          <div class="card-content-wrapper">
            <div class="card-front">
              <img class="card-icon" src="../assets/feature_logos/arrows-alt-h-solid.svg" alt="feather">
            </div>
            <div class="card-back">
              <h3>hosszú erőkar</h3>
              <p>A fokos alacsony tömege a becsapódási erőre negatív hatással van, amit a relatív hosszú nyél ellensúlyozni tud. A becsapódási erőt a tömeg és a sebesség határozza meg. A fokost sokan a kar meghosszabbításának is tekintik.</p>
            </div>
            <img class="aspect-ratio-guard" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="aspect-ratio-guard">
          </div>
        </div>

        <div class="break"></div>

        <div class="card" v-on:mouseleave="mouseleave">
          <div class="card-content-wrapper">
            <div class="card-front">
              <img class="card-icon" src="../assets/feature_logos/crosshairs-solid.svg" alt="feather">
            </div>
            <div class="card-back">
              <h3>becsapódási felület</h3>
              <p>A fokos vágó éle rövid, ami kis becsapódási felületen összpontosítja az ütés erejét, megnövelve az átütő képességet.</p>
            </div>
            <img class="aspect-ratio-guard" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="aspect-ratio-guard">
          </div>
        </div>

        <div class="card" v-on:mouseleave="mouseleave">
          <div class="card-content-wrapper">
            <div class="card-front">
              <img class="card-icon" src="../assets/feature_logos/balance-scale-solid.svg" alt="feather">
            </div>
            <div class="card-back">
              <h3>súlyeloszlás</h3>
              <p>A legtöbb baltaféléhez képest a fokos relatív kis feje révén rendkívül kiegyensúlyozott, így nagyon könnyű elsajátítani a használatát. A kiegyensúlyozás révén a rövidebb verziók célba dobásra is alkalmassá váltak.</p>
            </div>
            <img class="aspect-ratio-guard" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="aspect-ratio-guard">
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FeaturesSection",
  methods: {
    mouseleave: () => {
      const scrollToTop = () => document.getElementsByClassName("card-back").forEach(el => el.scrollTop = 0);
      setTimeout(scrollToTop, 400)
    },
  }
}
</script>

<style scoped>
.features-section-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: linear-gradient(180deg, #F2F2F2 0%, #EEEEEE 100%);
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 10vw;
  margin-right: 10vw;
  height: 100%;
  width: 100%;
  max-width: 1400px;
  padding-top: 7%;
  padding-bottom: 7%;
}

h2 {
  font-size: 64px;
  font-weight: 900;
  text-transform: uppercase;
}

#underline {
  background: #EFBE3E;
  height: 6px;
  width: 100%;
  border-radius: 10px;
}

.cards {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 260px;
  justify-content: space-between;
  margin-top: 10vh;
  flex-wrap: wrap;
}

.card {
  display: inline-block;
  width: 23%;
  background: transparent;
  perspective: 1000px;
}

.card-content-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.6s ease-in-out;
  transform-style: preserve-3d;
}

.card:hover .card-content-wrapper, .card:active .card-content-wrapper {
  transform: rotateY(180deg);
}

.card-front, .card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  border-radius: 10px;
  box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.25);
}

.card-back::-webkit-scrollbar {
  display: none;
}

.card-front {
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-back {
  overflow-x: hidden;
  overflow-y: scroll;
  background-color: #EFBE3E;
  transform: rotateY(180deg);
  padding: 10%;
  -ms-overflow-style: none;
}

.card-icon {
  width: 35%;
}

.aspect-ratio-guard {
  display:block;
  width: 100%;
  height: auto;
}

h3 {
  text-align: center;
  text-transform: uppercase;
  font-size: 22px;
  font-weight: bold;
  color: #3C3C3C;
}

p {
  font-size: 18px;
  margin-top: 5%;
  line-height: 1.5;
  color: #3C3C3C;
}

.break {
  display: none;
  flex-basis: 100%;
  height: 0;
}

@media only screen and (max-width: 1400px) {
  .cards {
    margin-top: 80px;
    justify-content: center;
  }

  .break {
    display: block;
  }

  .card {
    min-width: 280px;
    margin: 20px;
  }

  h2 {
    margin-top: 25px;
  }
}

@media only screen and (max-width: 900px) {
  .features-section-container {
    display: none;
  }
}

</style>
